import logo from './logo.svg';
import './App.css';
import React, { useEffect } from 'react';
import Header from './Header';
import "./App.css";
import Section from './Section';
import Footer from './Footer';
import MenuSection from './MenuSection';
import SwitchSection from './SwitchSection';
import { useState } from 'react';
import ClipLoader from "react-spinners/ClipLoader";


const App = () => {

  const [isLoading, setIsLoading] = useState(true);
  window.addEventListener("load", () => {
    setIsLoading(false);
  });

  //when page is reset, change isLoading to true
  useEffect(() => {
    setIsLoading(false);
  }, [window.location.href]);


 

  return (isLoading ? <div className="spinner"> <ClipLoader color={"dimgrey"}
  size={150}
  ></ClipLoader> </div> :
    <div>
      <div className="header"><Header></Header></div>

      <div className = "content">
      <div className="menu">
      <a href="#about-me"><MenuSection text="About Me"></MenuSection></a>
      <a href="#work-experience"><MenuSection text="Work Experience"></MenuSection></a>
      <a href="#projects"><MenuSection text="Projects"></MenuSection></a>
      <a href="#contact-me"><MenuSection text="Contact Me"></MenuSection></a>
      </div>
      <div className="sections">
        <a id="about-me"><Section title="About Me" text={
              <div> 
                <p>Hello World, my name is Bayley Sapara. I am a technical designer/gameplay programmer based in Canada who specializes in designing and implementing gameplay systems and integrating them with GenAI-driven behaviour systems.
                </p>
                <br></br>
                <p>
                I am currently working on the Technical Design team at Artificial.Agency, creating game-like example content for customers and having an absolute blast. A huge challenge in this position is developing game systems that are usable by both human players and GenAI-driven agents. My journey in software development has given me a broad technical toolkit and a passion for designing systems that are intuitive, well-structured, and expressive — making them enjoyable for players while remaining clear and reliable for AI agents to reason about.
                </p>
                </div>
              }></Section></a>
        <a id="work-experience"><SwitchSection title="Work Experience" titles={["Associate Techincal Designer", "Research Assistant", "Junior Software Developer", "Teaching Assistant", "Administrative Work Experience"]} reverse={false}
        content={[
          <div>Since July 2024, I have been working as an Associate Technical Designer at Artificial.Agency, a company that specializes in creating GenAI-driven content that can be integrated into game development. 
            My work primarily involves building gameplay systems 
                 and user interfaces using Unreal Blueprints, with occasional contributions in C++. I focus on designing intuitive UI, integrating gameplay systems (such as dialogue systems, puzzle system, and an equipment system), and connecting NPCs to LLM-powered 
                 AI behavior pipelines. My role requires fast-paced iteration, independent creative decision-making, and a strong ability to merge traditional game development techniques with an ever-changing GenAI landscape. 
          </div>,
          <div>From May 2022 to May 2024, I worked with a team from the University of Alberta Marketing Department,
            designing and programming a web application in which the user completes games and data was sent back to an SQL database
            for the use of research. This position involved a lot of self-directed learning and independent problem-solving and has given me experience with Javascript, SQL, and Coldfusion.
          </div>,
          <div>From December 2022 to August 2023 I was employed with Alberta Language Technology Labs, which is based in the University of Alberta Linguistics department.
            In this role, I worked mainly on frontend web development with the goal of refactoring their Plains Cree to English dictionary, itwewina, to use the React framework. In this position an attention to detail was key. 
            Other skills involved were code review of others on the team, and communication skills with a client who had limited programming knowledge.
          </div>,
          <div>I have held two Teaching Assistant Positions at the University of Alberta during my undergrad career, both for the intro course CMPUT 174.
            In one of the semesters, I was part of a specialized team which reviewed content before it was released to students to ensure difficulty was appropriate for the students 
            and there would be little room for misinterpretation of the assignments and tests. I have a passion for educating others in programming, especialy novices, and I found these positions to be very rewarding.
          </div>,
          <div>
            I have held two full-time administrative positions in the past, one at a local newspaper and one working for the municipal government in Vegreville, AB. 
            These jobs had similar responsibilities including data entry, customer service, and general office duties.
            I gained a variety of professional skills from these positions, such as time management, communication, and attention to detail.
            These positions required a combination of interpersonal skills and the ability to work independently. 
            I believe that they gave me a strong foundation on top of which to build my skills as a developer.
          </div>
        ]}
        
        
        ></SwitchSection></a>
        <a id="projects"><SwitchSection title="Projects" titles={[
           "Baldur's Gate 3 Mod", "Infernal Blodrush", "Lizard vs Dad", "Energy Adventure", "Spatial Foraging Task", "Social Distribution Media App", "Down to Earth", "Hunted House", "Plunderstorm"
        ]} reverse={false}
         content={[ 
          <div>
            Baldur's Gate 3 Mod
            <br></br>
            <br></br>
            In December 2025, I worked with two other developers to create a Baldur's Gate 3 mod which overrode existing gameplay systems and replaced them with GenAI-driven behaviour using BG3 Script Extender. We focused primarily on dialogue, creating a system which resulted in an entirely new experience with each playthrough. We created an agent to provide dialogue options for the player each time a dialogue sequence was inititated, based on perceptions we provided of the environment and runtime actions taken by other agents. Most NPCs were powered by LLM-driven agents as well. All NPC dialogue was generated at runtime, and the NPCs were given additional actions they could take in dialogue sequences, including gifting items to the player, attacking the player, or ending the conversation peacefully. We also generated custom combat barks at runtime, including for hit reactions, miss reactions, and death barks. For a more immersive experience, we fed all dialogue lines and combat barks through ElevenLabs to create voiceover lines at runtime, with custom voices designed to sound similar to characters existing in the game. 
            <br></br>
            <br></br>
            Unfortunately, I cannot show screen captures of this project due to the terms of my company NDA, and concerns about the use of Larian IP. 
          </div>, 
          <div>
            Infernal Bloodrush
            <br></br>
            <br></br>
            In Winter 2024, I worked with a team of four other developers to create a 2.5D first-person Doom-like action game. I was responsible for UI/UX design and programming, and map design.
            This game was made for the capstone project of the Game Development Certificate at the University of Alberta, and was a culmination of all the skills I had learned in the program.
            <br></br>
            <br></br>
            We have since then received funding from the ESIO Trailhead program to continue development of this game and display it at Game Con Canada 2024. We will also be showcasing it at GDX 2024.
            <br></br>
            <br></br>
            <a className="links" href="https://store.steampowered.com/app/3041890/Infernal_Bloodrush/">Click here for our steam page.</a>
          </div>, 
          <div>
          Lizard vs Dad
          <br></br>
          <br></br>
          In May 2025, I created this game with two other developers in a self-directed hackathon. It is a 3D platformer where
          you play as a lizard trying to escape from a dad who is trying to smack you with a slipper. I contributed to the game design, level design, and UI programming.
          <br></br>
          <br></br>
          <a className="links" href="https://teyplays.itch.io/lizard-vs-dad">Click here to play the game.</a>
        </div>,
          <div>
            Energy Adventure
            <br></br>
            <br></br>
            In Fall 2023, I worked with Future Energy Systems and a team of 5 other developers 
            to create a game with the goal of educating children about energy consumption and conservation. We created a point and click adventure
            with mini-challenges such as videos or puzzles to give the player more information about energy systems and the environment.
            <br></br>
            <br></br>
            I acted as the Scrum Master for this project, and was responsible for delegation of tasks and ensuring the project was on track to meet deadlines.
            I also worked with the Unity engine to bring our client's vision to life, engineering the badge system present on the game map.
            <br></br>
            <br></br>
            <a className="links" href="https://cmput401.ca/projects/110c4678-f036-4100-ba19-7fc3f596412b">Click here for more information</a>
          </div>, 

          <div>
            Spatial Foraging Task
            <br></br>
            <br></br>
            This project is ongoing, and is being developed for my current Research Assistant position. I independently created a web application to support
            the research of Gerald Haeubl, a professor in the Marketing Department. This application is a series of simple games made in JavaScript Canvas
            which are used to collect data for research. The data is then sent to a SQL database for analysis. 
            <br></br>
            <br></br>
            The Spatial Foraging Task has a special place in my heart,
            since I was learning Javascript completely from scratch while trying to ensure I was producing quality software for my client.
            <br></br>
            <br></br>
            <a className="links" href="https://youtu.be/DTsbVRlcVRQ">Click here to see a demo</a>
          </div>, 
          
          
          <div>
            Social Distribution Media App
            <br></br>
            <br></br>
            In Winter 2023, I worked with a team of 4 other developers to create a social media app using Django and React, and originally deployed on Heroku. I mainly worked on frontend aspects of this web application, including the display of posts and images, and the friend requests system.
            While I had worked with React before, this project taught me so much more about the framework and how to use it to create a dynamic, responsive web application. While I did not work much with Django, it was a valuable learning experience to see how backend and frontend systems must communicate 
            to create a cohesive application.
            <br></br>
            <br></br>
            Our app is no longer supported on Heroku,&nbsp;
            <a className="links" href="https://www.youtube.com/watch?v=OnOKN7GfFXU">but you can see a demo of it here</a>.
            
            
             </div>, 

          <div>
            Down to Earth
            <br></br>
            <br></br>
            I participated in the Global Game Jam of January 2023, a 48 hour hackahton where teams from all over the world create games based on a theme.
            The chosen theme that year was "roots", so my team and I created a game called Down to Earth, where you play as a tree who must grow their roots to collect water and nutrients.
            I was solely responsible for the level design and mechanics of this game.
            Myself and other teammates were first introduced to the Unity engine during this project, and
            to say it was a challenge to try to master Unity in under 48 hours is an understatement. However, I am proud of the work my team and I did during this short time.
            <br></br>
            <br></br>
            <a className="links" href="https://ganeshsar.itch.io/down-to-earth">Click here to play the game</a>
          </div>, 

          <div>
            Hunted House
            <br></br>
            <br></br>
            The first hackathon I ever participated in was NatHacks 2022. It was 64 hours long and themed around the use of brain-scanning hardware. Myself and the two other developers on my team did a lot of preparation for this hackathon.
            We learned how to use the Muse 2 headband to scan brainwaves and detect the player's level of focus, and created a horror game which responded at runtime to the player's concentration levels to optimize jumpscare potential.
            <br></br>
            <br></br>
            My teammates worked on translating information from the headband into data that would be usable by the game, and I was solely responsible for the game design and game-related programming of this project.
            We used Python Arcade which was easy to learn over the course of the hackathon, and assets from RPGMaker (as we did not have an artist among us). 

            It was an incredibly rewarding experience to see our project come to life in such a short time. Our game is unforutunately not playable without the Muse 2 hardware,
            but&nbsp;
            <a className="links" href="https://devpost.com/software/hunted-house">you can see our presentation and demo here</a>.

          </div>,

        <div>
        Plunderstorm
            <br></br>
            <br></br>  
        In Winter 2023, I participated in a Game Design Principles & Practice course at the University of Alberta.
        This course was based around the importance of paper prototyping when in the design stages of game development.
        I worked with a team of 2 other students to create a game called Plunderstorm, which won an award for "Amazingly Fun and Immediatetely Want to Play Again".
        <br></br>
        <br></br>
        Making Plunderstorm, a paper-based game where 3-4 pirate Captains battle against 1 Commander who is positioned ashore, was one of the most interesting game design experiences
        I have ever had. Due to the asymetrical nature of the game and the large number of moving parts we had, it involved many hours of ideating and playtesting to end with a design that we felt was satisfying and fun to play.


        </div>
        ]
        }></SwitchSection></a>
        
        
        
        
        
        <a id="contact-me"><Section title="Contact Me"  text={
        <div> 
                <p>My inbox is always open. Feel free to email me, or reach out on LinkedIn if you have a question or just want to say hello!</p>
                <p>I would love to chat about my experience and relevant job oppurtunities. </p>
                <br></br>
                <p>Email:&nbsp;
                <a  className="contact-me-links" href="mailto:bayleysapara@gmail.com">bayleysapara@gmail.com</a>
                </p>
                <p>LinkedIn:&nbsp;
                <a className="contact-me-links" href="https://www.linkedin.com/in/bayley-sapara-181170224/">https://www.linkedin.com/in/bayley-sapara-181170224/ </a>
                </p>
                <p>Github:&nbsp;
                <a className="contact-me-links" href="https://github.com/Eluviian">https://github.com/Eluviian</a>
                </p>
                
                </div>}
                
                >
          
          </Section></a>
        
        

    </div>

    </div>

    <Footer></Footer>
    </div>
    
  )
}

export default App;
